const DateTimeField = ({
  label,
  dateValue,
  timeValue,
  onDateChange,
  onTimeChange,
  dateType = "date",
}) => {
  return (
    <div className="form-group">
      <label className="d-block fs-sm fw-semibold mb-2">{label}</label>
      <div className="row">
        <div className="col-6">
          <input
            type={dateType}
            className="form-control fs-sm shadow-none border border-gray-300"
            value={dateValue}
            onChange={onDateChange}
          />
        </div>
        {dateType === "date" && (
          <div className="col-6">
            <input
              type="time"
              className="form-control fs-sm shadow-none border border-gray-300"
              value={timeValue}
              onChange={onTimeChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DateTimeField;
